import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import "../style/services-usa/shopify-web-development/_banner.scss"
import BgImg from "../../images/services-usa/shopify-web-development/banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service shopify-banner overflow-x-hidden"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              {/* <h1 className="web_head_banner">Build Scalable Cloud Apps</h1> */}
              <h1 style={{ marginBottom: "15px" }}>
                Shopify Website Design And Development Services
              </h1>
              <p className="bottom-heading">Build Dynamic, High-Converting Shopify Stores</p>
              <p>
                Create a unique Shopify store with our secure, custom, and
                SEO-optimized web development services that make your brand
                stand out.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Book a Consultation Today
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
